import {buildUrlQuery} from "../../utils/build-url-query";
import {cache0} from "../../utils/cache0";

export const NextSocialApis = ({host, fetcher, share_location}) => ({
    getSocialMediaStatus: async () => fetcher.getJson(`/next-api/program/social_media_status`),

    getFbSocial: async ({agentId=undefined}={}) => fetcher.getJson(`/next/ajax/social_ajax.php` + buildUrlQuery({
        action: "fb_linked_account",
        redirect: location.href,
        entity_type: "Agent",
        share_location,
        id_entity: agentId,
    })),
    getTwSocial: async ({agentId=undefined}={}) => fetcher.getJson(`/next/ajax/social_ajax.php` + buildUrlQuery({
        action: "tw_linked_account",
        redirect: location.href,
        entity_type: "Agent",
        share_location,
        id_entity: agentId,
    })),
    getLiSocial: async ({agentId=undefined}={}) => fetcher.getJson(`/next/ajax/social_ajax.php` + buildUrlQuery({
        action: "li_linked_account",
        redirect: location.href,
        entity_type: "Agent",
        share_location,
        id_entity: agentId,
    })),
    getPiSocial: async ({agentId=undefined}={}) => fetcher.getJson(`/next/ajax/social_ajax.php` + buildUrlQuery({
        action: "pi_linked_account",
        redirect: location.href,
        entity_type: "Agent",
        share_location,
        id_entity: agentId,
    })),

    removeFbSocial: async ({agentId=undefined}={}) => fetcher.getJson(`/next/ajax/social_ajax.php` + buildUrlQuery({
        action: "fb_unlink_account",
        redirect: location.href,
        entity_type: "Agent",
        share_location,
        id_entity: agentId,
    })),
    removeTwSocial: async ({agentId=undefined}={}) => fetcher.getJson(`/next/ajax/social_ajax.php` + buildUrlQuery({
        action: "tw_unlink_account",
        entity_type: "Agent",
        share_location,
        id_entity: agentId,
    })),
    removeLiSocial: async ({agentId=undefined}={}) => fetcher.getJson(`/next/ajax/social_ajax.php` + buildUrlQuery({
        action: "li_unlink_account",
        entity_type: "Agent",
        share_location,
        id_entity: agentId,
    })),
    removePiSocial: async ({agentId=undefined}={}) => fetcher.getJson(`/next/ajax/social_ajax.php` + buildUrlQuery({
        action: "pi_unlink_account",
        entity_type: "Agent",
        share_location,
        id_entity: agentId,
    })),


    // Sharing to facebook and linkedin will not work if host = localhost:8523. Change host in url query string to a valid url ex)https://apm-dev.awsdev.xpressdocs.com
    shareFbPage: async ({pageIndex, url, comment, image, id_group_post = 0}) => fetcher.getJson(
        `/next/ajax/social_ajax.php` +
        buildUrlQuery({
            action: "fb_post_page",
            message: comment,
            url: (host || getBrowserHost()) + url,
            image,
            page_index: pageIndex,
            entity_type: "Agent",
            share_location,
            fb_share: 1,
            ig_share: 0,
            id_group_post
        })
        // action=fb_post_page&
        // message=${encodeURIComponent(comment)}&
        // url=${encodeURIComponent((host || getBrowserHost()) + url)}&
        // image=${encodeURIComponent(ccImage)}&
        // page_index=${pageIndex}&
        // entity_type=Agent&
        // share_location=apm2&fb_share=${+fb_share}&ig_share=${+ig_share}`),
    ),
    //Meta sharing includes two new variables to set what platforms should receive the post
    shareIgPage: async ({url, comment, image, id_group_post = 0}) => fetcher.getJson(
        `/next/ajax/social_ajax.php` +
        buildUrlQuery({
            action: "fb_post_page",
            message: comment,
            url: (host || getBrowserHost()) + url,
            image,
            // page_index: pageIndex,
            entity_type: "Agent",
            share_location,
            fb_share: 0,
            ig_share: 1,
            id_group_post,
        })
    ),
    // -> {action: true / false}
    shareTwPage: async ({url, comment, id_group_post = 0}) => fetcher.getJson(
        `/next/ajax/social_ajax.php` +
        buildUrlQuery({
            action: "tw_post_status",
            message: comment,
            url: (host || getBrowserHost()) + url,
            entity_type: "Agent",
            share_location,
            id_group_post,
        })
        // `?action=tw_post_status&message=${encodeURIComponent(comment)}&url=${encodeURIComponent((host || getBrowserHost()) + url)}&entity_type=Agent&share_location=apm2`
    ),
    // -> {action: true / false}
    shareLiPage: async ({url, comment, headline, image, id_group_post = 0}) => fetcher.getJson(
        `/next/ajax/social_ajax.php` +
        buildUrlQuery({
            action: "li_post_page",
            headline: headline,
            message: comment,
            link: (host || getBrowserHost()) + url,
            image,
            entity_type: "Agent",
            share_location,
            id_group_post,
        })
        // `?action=li_post_page&headline=${encodeURIComponent(headline)}&
        // message=${encodeURIComponent(comment)}&
        // link=${encodeURIComponent((host || getBrowserHost()) + url)}&
        // image=${encodeURIComponent(ccImage)}&entity_type=Agent&share_location=apm2`
    ),
    // -> {action: true / false}
    sharePiPage: async ({url, comment, image}) => fetcher.getJson(
        `/next/ajax/social_ajax.php` +

        buildUrlQuery({
            action: "pi_post_page",
            image,
            message: comment,
            link: url,
            entity_type: "Agent",
            share_location,
        })
        // `?action=pi_post_page&image=${encodeURIComponent(image)}&
        // message=${comment}&
        // link=${encodeURIComponent(url)}&entity_type=Agent&share_location=apm2`
    ),

    deletePostFb: async (idPrimary) => fetcher.deleteJson(
        `/next-api/social/facebook/post_delete/${idPrimary}`
    ),

    deletePostTw: async (idPrimary) => fetcher.deleteJson(
        `/next-api/social/twitter/post_delete/${idPrimary}`
    ),

    deletePostLi: async (idPrimary) => fetcher.deleteJson(
        `/next-api/social/linkedin/post_delete/${idPrimary}`
    ),

    deschedulePost: async (idPrimary) => fetcher.deleteJson(
        `/next-api/social/post_deschedule/${idPrimary}`
    ),

    reschedulePost: async ({share_ref_id, date_scheduled, share_location, entity_type}) => fetcher.getJson(
        `/next/ajax/social_ajax.php` +

        buildUrlQuery({
            action: "reschedule",
            share_ref_id,
            date_scheduled,
            share_location,
            entity_type
        })
    ),

    // -> {action: true / false}
    socialPostV2: async ({url, comment, date_scheduled, image, socialSite, pageIndex=undefined, id_group_post, source_id=undefined, source_type=undefined}) => fetcher.getJson(
        `/next/ajax/social_ajax.php` +

        buildUrlQuery({
            action: "socialPostV2",
            // image,
            // message: comment,
            // link: url,
            socialSite,
            date_scheduled,
            // title: "Testing", // TODO We don't have title
            message: comment,
            imageUrl: image,
            pageIndex, // TODO Ask: can't send every time if not FB
            entity_type: "Agent",
            share_location,
            redirectUrl: url,
            source_id:source_id,
            source_type: source_type,
            id_group_post,
        })
    ),
    // -> {action: true / false}


    requestFbBusinessPageLink: async ({pageId, agentId, pageName}) => {
        return fetcher.postJson("/next-api/social/request_client_page", {
            "entityType":"Agent",
            "idEntity":"" + agentId,
            "pageId":"" + pageId,
            "pageName":"" + pageName,
        });
    },

    cancelFbBusinessPageLink: async (pageId) => fetcher.deleteJson(`/next-api/social/delete_client_page/${pageId}`),

    getFbClientPageRequestStatus: async ({pageId}) => fetcher.getJson(`/next-api/social/client_page_request_status/${pageId}`),

    getFbBusinessPageClientApprovalUrl: ({businessId, agentId}) => {

        return fetcher.postJson("/next-api/social/get_client_approval_url", {
            "entityType":"Agent",
            idEntity: "" + agentId,
            businessId: "" + businessId,
        });

    },
    getFbPages: ({agentId}) => {
        return fetcher.getJson(
            `/next-api/social/get_social_pages/Agent/` +
            encodeURIComponent("" + agentId)
        );
    },
});

const getBrowserHost = cache0(() => {
    const {protocol, host} = window.location;
    return protocol + "//" + host;
});
